"use client";

import { SkeletonLine, useStylesConfigValue } from "@health/ui";

function InsightDot({ className = "" }: { className?: string }) {
  return <span className={`inline-block w-1.5 h-1.5 rounded-full bg-brand-teal ${className}`} />;
}

/**
 * Loading skeleton mirroring the full ReasoningTrace card — fact line,
 * inference line, and a small action affordance on the right.
 *
 * Lives in its own file so {@link WidgetLoadingRegistry} can import it
 * without pulling in the lazy-loaded {@link ReasoningTrace} chunk.
 *
 * Mirrors `ReasoningTrace`'s own render gate: returns `null` when
 * `traceMode === "disabled"` so the skeleton never flashes before the
 * suppressed widget mounts.
 */
export function ReasoningTraceSkeleton() {
  const traceMode = useStylesConfigValue("traceMode");
  if (traceMode === "disabled") return null;

  return (
    <div className="w-full">
      <div className="rounded-2xl bg-secondary/30 border border-secondary/60 px-4 py-3 space-y-1.5">
        <div className="flex items-start gap-2">
          <InsightDot className="mt-1.5" />
          <SkeletonLine $size="text" $width="lg" />
        </div>
        <div className="flex items-start gap-2 pl-4">
          <SkeletonLine $size="text" $width="md" />
        </div>
        <div className="flex justify-end pt-1">
          <SkeletonLine $size="caption" $width="sm" />
        </div>
      </div>
    </div>
  );
}
